document.addEventListener('DOMContentLoaded', () => {
    const openModal = (trigger) => {
        const modal = trigger.closest('.fusion-modal');
        modal.setAttribute('data-open', 'true');

        const template = modal.querySelector('.fusion-modal__content-template');
        const clone = template.content.cloneNode(true);
        const target = modal.querySelector('.fusion-modal__content-template-target');

        target.innerHTML = '';
        target.appendChild(clone);
    };

    const closeModal = (close) => {
        const modal = close.closest('.fusion-modal');
        modal.setAttribute('data-open', 'false');

        const target = modal.querySelector('.fusion-modal__content-template-target');
        target.innerHTML = '';
    };

    document.querySelectorAll('.fusion-modal__trigger').forEach((trigger) => {
        trigger.addEventListener('click', () => openModal(trigger), { passive: true });
    });

    document.querySelectorAll('.fusion-modal__close').forEach((close) => {
        close.addEventListener('click', () => closeModal(close), { passive: true });
    });

    document.querySelectorAll('.fusion-modal__overlay').forEach((overlay) => {
        overlay.addEventListener('click', () => closeModal(overlay), { passive: true });
    });
});
